import React, { useEffect, useState } from 'react'
import "./Preloader.css"

export default function Preloader() {

    const [active, setActive] = useState(true);


    useEffect(() => {
        setTimeout(() => {
            setActive(false);
        }, 1200)
    }, [])

    return (
        <>
            {
                active && <div className='preloader'>
                    <img src="https://www.aseguramalapraxis.com/img/assets/preloader_1.gif" alt="" />
                </div>
            }
        </>

    )
}
